import { variant } from 'styled-system';

const typeVariant = () =>
  variant({
    prop: 'type',
    variants: {
      block: {
        fontFamily: 'body',
        fontSize: 'headings.3',
        fontWeight: 'normal',
        lineHeight: 1.5,
      },
      transparent: {
        fontSize: 'headings.2',
        lineHeight: 1.2,
        fontWeight: 'medium',
      },
    },
  });

export default typeVariant;
